import React, {createContext, useContext, useState, ReactNode, useEffect} from 'react';
import useSetParamsURL from '../../../../../lib/useSetParamsURL';
import DialogDetalhePrescricao from "./DialogDetalhePrescricao";
import {Stack, Typography} from "@mui/material";

interface ModalDetalhePrescricaoContextType {
    openModal: (idPrescricao: string) => void;
    closeModal: () => void;
}


const ModalDetalhePrescricaoContext = createContext<ModalDetalhePrescricaoContextType | undefined>(undefined);


export const ModalDetalhePrescricaoProvider: React.FC<{ children: ReactNode }> = ({children}) => {

    const {searchParams, clearSingleParamUrl} = useSetParamsURL();

    const prescricaoIdFromUrl = searchParams.get('detalhe-prescricao');


    const [isOpen, setIsOpen] = useState(Boolean(prescricaoIdFromUrl));
    const [itemValue, setItemValue] = useState<string | null>(prescricaoIdFromUrl);

    const openModal = (idPrescricao: string) => {
        setItemValue(idPrescricao);
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
        setItemValue(null);
        clearSingleParamUrl("detalhe-prescricao");
    };

    useEffect(() => {

        if (prescricaoIdFromUrl) {
            setItemValue(prescricaoIdFromUrl);
            setIsOpen(true);
        } else if (isOpen) {
            closeModal();
        }
    }, [prescricaoIdFromUrl]);

    return (
        <ModalDetalhePrescricaoContext.Provider value={{openModal, closeModal}}>
            {children}
            {
                (itemValue && isOpen) &&
                <DialogDetalhePrescricao
                    open={isOpen}
                    prescricaoId={itemValue}
                    handleClose={closeModal}
                />
            }
        </ModalDetalhePrescricaoContext.Provider>
    );
};


interface DadosTitulosItemsProps {
    titulo: string;
    valor: string | number | null | undefined;
}

export const DadosTitulosItems: React.FC<DadosTitulosItemsProps> = ({
                                                                        titulo,
                                                                        valor
                                                                    }) => {
    return (
        <Stack>
            <Typography fontWeight="bold" variant="subtitle2">{titulo}</Typography>
            <Typography variant="subtitle2">{valor ?? 'Não informado'}</Typography>
        </Stack>
    )
}

export const useModalDetalhePrescricao = (): ModalDetalhePrescricaoContextType => {
    const context = useContext(ModalDetalhePrescricaoContext);
    if (!context) {
        throw new Error('useModalDetalhePrescricao must be used within a ModalDetalhePrescricaoProvider');
    }
    return context;
};